module.exports = __webpack_public_path__ + "img/1-2.4170a502.svg";